import { useEffect } from 'react'
import { useState } from 'react'
import ContentLoader from 'react-content-loader'

import './page-loading.scss'

export const PageLoading = () => {
    const [show, setShow] = useState<boolean>(false)

    useEffect(() => {
        let t = setTimeout(() => {
            setShow(true)
        }, 100)
        return () => clearTimeout(t)
    }, [])

    if (!show) return null

    return (
        <div className="progress">
            <span className="progress-bar"></span>
        </div>
    )

    // Keeping this
    // return (
    //     <div className="page-loader" style={{ width: '100%', padding: '30px', boxSizing: 'border-box' }}>
    //         <ContentLoader height={200} width="100%" speed={1} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
    //             {/* Only SVG shapes */}
    //             <rect x="0" y="0" rx="10" ry="10" width="100%" height="25" />
    //             <rect x="0" y="50" rx="10" ry="10" width="90%" height="25" />
    //             <rect x="0" y="100" rx="10" ry="10" width="70%" height="25" />
    //             <rect x="0" y="150" rx="10" ry="10" width="80%" height="25" />
    //         </ContentLoader>
    //     </div>
    // )
}
